import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const PopulationIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0004 5.967C14.9504 5.95866 14.8921 5.95866 14.8421 5.967C13.6921 5.92533 12.7754 4.98366 12.7754 3.81699C12.7754 2.62533 13.7337 1.66699 14.9254 1.66699C16.1171 1.66699 17.0754 2.63366 17.0754 3.81699C17.0671 4.98366 16.1504 5.92533 15.0004 5.967Z"
        stroke="#13212F"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.1422 12.0338C15.2839 12.2255 16.5422 12.0255 17.4255 11.4338C18.6005 10.6505 18.6005 9.36713 17.4255 8.58379C16.5339 7.99213 15.2589 7.79212 14.1172 7.99212"
        stroke="#13212F"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M4.97344 5.967C5.02344 5.95866 5.08177 5.95866 5.13177 5.967C6.28177 5.92533 7.19844 4.98366 7.19844 3.81699C7.19844 2.62533 6.24011 1.66699 5.04844 1.66699C3.85677 1.66699 2.89844 2.63366 2.89844 3.81699C2.90677 4.98366 3.82344 5.92533 4.97344 5.967Z"
        stroke="#13212F"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5.83255 12.0338C4.69088 12.2255 3.43255 12.0255 2.54922 11.4338C1.37422 10.6505 1.37422 9.36713 2.54922 8.58379C3.44089 7.99213 4.71588 7.79212 5.85755 7.99212"
        stroke="#13212F"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.99844 12.1921C9.94844 12.1838 9.8901 12.1838 9.8401 12.1921C8.6901 12.1504 7.77344 11.2088 7.77344 10.0421C7.77344 8.85042 8.73177 7.89209 9.92344 7.89209C11.1151 7.89209 12.0734 8.85876 12.0734 10.0421C12.0651 11.2088 11.1484 12.1588 9.99844 12.1921Z"
        stroke="#13212F"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.57461 14.8173C6.39961 15.6006 6.39961 16.884 7.57461 17.6673C8.90794 18.559 11.0913 18.559 12.4246 17.6673C13.5996 16.884 13.5996 15.6006 12.4246 14.8173C11.0996 13.934 8.90794 13.934 7.57461 14.8173Z"
        stroke="#13212F"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}
